import { ElementRef, HostListener, Injectable, ViewChild } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { ValidationHandlerService } from './validation-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageService } from './language.service';
import { AuthSubscriptionService } from './auth-subscription.service';
import { ClaimTypes } from '../claim-types';
import { LocalStorageWrapper } from '../classes/local-storage-wrapper.class';
import { HttpErrorResponse } from '@angular/common/http';
import { ICoreService } from '../interfaces/core-service.interface';
import { IAuthenticationService } from '../interfaces/authentication-service.interface';
import { LanguageListModel, LanguageListModelListBaseResponse } from '../types/language-list.model';
import { LanguageId } from '../enums/language-id.enum';
declare var $: any;

@Injectable()
export class MenuBaseService {
    public showMenu: boolean;
    public languages: LanguageListModel[];
    public user: string;
    public selectedLanguage: string;

    private subscriptionFirst?: Subscription;

    private coreService: ICoreService;
    private authenticationService: IAuthenticationService;

    constructor(
        private validationHandlerService: ValidationHandlerService,
        private translateService: TranslateService,
        private spinnerService: NgxSpinnerService,
        private languageService: LanguageService,
        private authSubscriptionService: AuthSubscriptionService
    ) {}

    onInitFunction(coreService: ICoreService, authenticationService: IAuthenticationService) {
        this.authenticationService = authenticationService;
        this.coreService = coreService;

        this.init();

        this.subscriptionFirst = this.authSubscriptionService.authChanged.subscribe((isUserAuthenticated: boolean) => {
            this.showMenu = isUserAuthenticated;

            if (this.showMenu) {
                let dToken = authenticationService.getDecodedToken();
                this.user = dToken[ClaimTypes.Email];
            }
        });
    }

    onDestroyFunction() {
        if (this.subscriptionFirst) {
            this.subscriptionFirst.unsubscribe();
        }
    }

    public init() {
        firstValueFrom(this.coreService.getLanguageList())
            .then((res: LanguageListModelListBaseResponse) => {
                this.languages = res.result;
                let languageStrings: string[] = this.languages.map((a: LanguageListModel) => a.shortCode);
                this.translateService.addLangs(languageStrings);
                if (LocalStorageWrapper.isLocaleSet()) {
                    this.translateService.setDefaultLang(LocalStorageWrapper.getLocale());
                    this.translateService.use(LocalStorageWrapper.getLocale());
                } else {
                    let defaultLanguage = this.languages.find(x => x.id == LanguageId.En);
                    let defaultLocale = defaultLanguage.shortCode;
                    this.translateService.setDefaultLang(defaultLocale);
                    this.translateService.use(defaultLocale);
                    LocalStorageWrapper.setLocale(defaultLocale, defaultLanguage.id);
                    this.languageService.changeLanguage(defaultLocale);
                }
                this.initSelect();
                this.selectedLanguage = LocalStorageWrapper.getLocale();
                return Promise.resolve(res);
            })
            .catch((err: HttpErrorResponse) => {
                this.validationHandlerService.handleServerError(err);
            });
    }

    public initSelect(): void {
        $('#languageSelector').select2({
            templateResult: formatLanguage,
            templateSelection: formatLanguage,
        });

        $('#languageSelector').on('select2:select', (languageSelector: any) => {
            this.changeLanguage(languageSelector.target.value);
        });

        function formatLanguage(language: any) {
            var name = $(language.element).data('name');
            var $language = $('<span style="font-size: 1rem">' + name + '</span>');
            return $language;
        }
    }

    public changeLanguage(languageShortCode: any) {
        let language: string = languageShortCode;
        this.translateService.use(language);
        this.translateService.setDefaultLang(language);
        let defaultLanguage = this.languages.find(x => x.shortCode == languageShortCode);
        LocalStorageWrapper.setLocale(language, defaultLanguage.id);
        this.languageService.changeLanguage(language);
    }

    public logout() {
        this.authenticationService.logout();
    }
}
